
/**
 * Hours module
 *
 * This module handles business hours and custom hours along with being the core
 * module for daily times. And Holiday hours.
 *
 * @author MattJS (matt@yext.com)
 */
goog.provide('yext.location.hours.DayHours');
goog.provide('yext.location.hours');
goog.provide('yext.location.hours.holiday.HolidayHour');

goog.require('yext');
goog.require('yext.location.helpers');
goog.require('yext.location.hours.Hour');
/** @suppress {extraRequire} */
goog.require('yext.plugins.inputchange');
goog.require('yext.time');

/**
 * Invalid hour object
 *
 * Represents an issue with an hour for a portion of an interval
 *
 * @constructor
 * @param {!Object} data Invalid details
 */
yext.location.hours.InvalidHour = function(data) {
  this.day = data.day;
  this.date = data.date;
  this.property = data.property; // start or end
  this.index = data.index; // 0 or 1
  this.reason = data.reason; // TIME or RANGE
};

/**
 * Static constructor
 *
 * @return {InvalidHour} Invalid hour object
 */
yext.location.hours.InvalidHour.createDay = function(day, property, index, reason) {
  return new yext.location.hours.InvalidHour({
    day: day,
    property: property,
    index: index,
    reason: reason,
  });
};

/**
 * DayHours model
 *
 * This model is made to reflect the DayHours proto.
 *
 * @param {!jQuery} $element Container for the hours
 * @constructor
 */
yext.location.hours.DayHours = function($element, context) {
  this.$element = $element;
  this.$hoursMain = $element.find('.js-hours-main');
  this.$hoursTable = $element.find('.js-hours-table');
  this.$resetHours = $element.find('.js-reset-hours-wrap');
  this.$hoursSpecified = $element.find('.js-hours-specified');
  this.$fieldData = $element.find('.js-field-value');

  this.hoursSpecified = this.$hoursSpecified.prop('checked');
  this.indeterminate = !!this.$resetHours.data('value');
  this.hours = [];
  // Hours meta is a dictionary with days as keys and containing
  // reference to the corresponding hours model and all related UI components
  this.hoursMeta = {};
  this.storedValues = {};
  this.fieldName = $element.find('input[name="field"]').val();

  this.build();
  this.storeValues();
  this.dataBindings();
  this.otherBindings();
  if (context) {
    this.createHolidayHours(context);
  }
  this.setFieldData();

  this.assetOrOriginal = true;
  this.originalValue = this.$fieldData.val();
};

/**
 * Build Hours models and hours meta object
 */
yext.location.hours.DayHours.prototype.build = function() {
  var self = this;

  yext.time.days.forEach(function(day) {
    var gumi = yext.location.hours.initGumi(self.$element.find('.js-hours-type-' + day));
    var meta = {
      gumi: gumi,
      $hoursType: gumi.$select,
      $start: self.$element.find('.js-hours-' + day + '-start'),
      $end: self.$element.find('.js-hours-' + day + '-end'),
      $startSplit: self.$element.find('.js-hours-' + day + '-start-split'),
      $endSplit: self.$element.find('.js-hours-' + day + '-end-split'),
      $splitHours: self.$element.find('.js-split-hours-' + day),
    };

    yext.location.hours.getHourFromMeta(meta);
    meta.hour.day = day;

    self.hours.push(meta.hour);
    self.hoursMeta[day] = meta;

    $(meta.hour).on('updated.hour', function(e, update) {
      self.hourUpdated(day, update);
    });
  });
};

/**
 * Store the current values
 */
yext.location.hours.DayHours.prototype.storeValues = function() {
  var self = this;
  var hours = {};

  yext.time.days.forEach(function(day) {
    hours[day] = self.hoursMeta[day].hour.clone();
  });

  this.storedValues = {
    hoursSpecified: this.hoursSpecified,
    hours: hours,
    indeterminate: this.indeterminate,
  };

  if (this.holidayHours) {
    this.holidayHours.storeValues();
  }
};

/**
 * Do all the data bindings here
 */
yext.location.hours.DayHours.prototype.dataBindings = function() {
  var self = this;

  yext.time.days.forEach(function(day) {
    var meta = self.hoursMeta[day];
    yext.location.hours.intervalDataBindings(meta, function() {
      self.broadcast('updated');
    });
  });
};

/**
 * Do all the other bindings here
 */
yext.location.hours.DayHours.prototype.otherBindings = function() {
  var self = this;
  var monday = this.hoursMeta['MONDAY'].hour;

  this.$element.find('.js-hours-apply-to-all').click(function() {
    yext.time.days.forEach(function(day) {
      if (day !== 'MONDAY') {
        self.hoursMeta[day].hour.copy(monday);
      }
    });
  });

  this.$hoursSpecified.change(function() {
    self.hoursSpecified = $(this).prop('checked');
    self.$hoursTable.toggle(self.hoursSpecified);
    self.broadcast('updated');
  });

  this.$element.find('.js-reset-hours').click(function() {
    self.indeterminate = false;
    self.$resetHours.hide();
    self.$hoursMain.show();
    self.$hoursSpecified.prop('checked', true).trigger('change');
  });

  $(this).on('updated.hours', function() {
    self.setFieldData();
  });
};

/**
 * Triggered by an hour update message
 *
 * @param {string} day The day of the week
 * @param {!Object} update Details about the updates to the hour
 */
yext.location.hours.DayHours.prototype.hourUpdated = function(day, update) {
  var meta = this.hoursMeta[day];
  yext.location.hours.intervalUpdated(update, meta);
  if (update.type) {
    this.$element.find('.js-hours-type-' + day).find('li').each(function() {
      if (update.type === $(this).data('value')) {
        $(this).attr('data-selected', true);
      } else {
        $(this).attr('data-selected', false);
      }
    });
  }

  this.broadcast('updated');
};

/**
 * Broadcast updates to the overall DayHours model
 *
 * @param {string} message The message type
 */
yext.location.hours.DayHours.prototype.broadcast = function(message) {
  $(this).trigger(message + '.hours');
  $(this).trigger('update.list');
  $(this).trigger('update.struct');
  this.updateAssetOrOriginal(false);
};

/**
 * Set the hidden input with the value of the field
 */
yext.location.hours.DayHours.prototype.setFieldData = function() {
  var data = this.get();
  data.fieldUpdated = 'HOURS';
  this.$fieldData.val(yext.JSON.stringify(data));

  if (this.holidayHours) {
    this.holidayHours.setFieldData(data);
  }
};

/**
 * Package relevant field info to send to a parent struct.
 */
yext.location.hours.DayHours.prototype.getJSONData = function() {
  return {
    ['field']: this.fieldName,
    [this.fieldName + '.specified']: this.hoursSpecified,
    ['indeterminate']: this.indeterminate,
    [this.fieldName + '.timestamp']: this.getTimestamp(),
    ['hours']: JSON.parse(this.$fieldData.val()).hours,
  };
};

/**
 * The after save function when this hours field is a child of a struct.
 */
yext.location.hours.DayHours.prototype.setFromStruct = function(fieldValues, $display) {
  this.reconcile(fieldValues);
  this.storeValues();
  this.setFieldData();
  $display.empty().append(this.generateViewMarkup());

  // reset asset approvals values
  this.assetOrOriginal = true;
  this.originalValue = this.$fieldData.val();
};

/**
 * Apply values to this field from an asset. Also set the assetOrOriginal flag to true.
 */
yext.location.hours.DayHours.prototype.applyAsset = function(fieldValues) {
  this.reconcile(fieldValues);
  this.setFieldData();
  this.updateAssetOrOriginal(true);
};

/**
 * Update the asset or original flag.
 */
yext.location.hours.DayHours.prototype.updateAssetOrOriginal = function(fromAsset) {
  if (fromAsset || this.originalValue === this.$fieldData.val()) {
    this.assetOrOriginal = true;
  } else {
    this.assetOrOriginal = false;
  }
};

/**
 * Type-ubiquitous function for checking assetOrOriginal flag.
 */
yext.location.hours.DayHours.prototype.checkAssetOrOriginalFlag = function() {
  return this.assetOrOriginal;
};

/**
 * Get hours data
 *
 * @return {!Object} Hours and holiday hours data
 */
yext.location.hours.DayHours.prototype.get = function() {
  var hours = {};

  if (this.indeterminate) {
    hours.indeterminate = true;
  } else if (this.hoursSpecified) {
    hours.hours = this.hours;
  }

  if (this.holidayHours) {
    hours.holidayHours = this.holidayHours.get();
  }

  return hours;
};

/**
 * Reconcile backed with frontend
 *
 * @param {!Object} field Day hours details
 */
yext.location.hours.DayHours.prototype.reconcile = function(field) {
  var self = this;

  if (field.hours.length !== 0) {
    field.hours.forEach(function(hour) {
      self.hoursMeta[hour.day].hour.copy(hour);
    });
  } else { // Hours cleared
    this.hours.forEach(function(hour) {
      hour.clear();
    });
  }

  if (this.holidayHours) {
    this.holidayHours.reconcile(field.holidayHours);
  }
};

/**
 * Reset hours to pre-edit state when user hits cancel
 */
yext.location.hours.DayHours.prototype.reset = function() {
  var self = this;
  // Reset hours specified
  this.$hoursSpecified.prop('checked', this.storedValues.hoursSpecified);
  this.$hoursTable.toggle(this.storedValues.hoursSpecified);
  this.hoursSpecified = this.storedValues.hoursSpecified;
  // Reset indeterminate
  this.$resetHours.toggle(this.storedValues.indeterminate);
  this.$hoursMain.toggle(!this.storedValues.indeterminate);
  this.indeterminate = this.storedValues.indeterminate;
  // Reset hours
  yext.time.days.forEach(function(day) {
    var saved = self.storedValues.hours[day];
    self.hoursMeta[day].hour.copy(saved);
  });
};

/**
 * Generate view markup for hours
 *
 * @return {!jQuery|string} Markup as jquery or string
 */
yext.location.hours.DayHours.prototype.generateViewMarkup = function() {
  if (!this.hoursSpecified) {
    // TRANSLATORS: Shown when the user has not specified business hours
    return yext.msgc('hours', 'Not specified');
  }

  if (this.indeterminate) {
    return yext.location.helpers.variousContentMessage();
  }

  var self = this;

  var $table = yext.location.hours.generateHoursTable();

  yext.time.days.forEach(function(day) {
    var hour = self.hoursMeta[day].hour;
    var label = yext.time.dayAbbreviations[day];

    var $tr = yext.location.hours.generateHoursTableRow(label, hour);

    $table.append($tr);
  });

  return $table;
};

/**
 * Check to see if hours are invalid.
 *
 * Used currently with feed upload
 *
 * @return {!Array.<InvalidHour>} Array of InvalidHour objects or false
 */
yext.location.hours.DayHours.prototype.invalidHours = function() {
  var self = this;
  var invalidHours = [];

  yext.time.days.forEach(function(day) {
    var hour = self.hoursMeta[day].hour;
    if (hour.intervals.length > 0) {
      for (var i = 0; i < hour.intervals.length; i++) {
        if (!hour.intervals[i].start ^ !hour.intervals[i].end) {
          invalidHours.push(yext.location.hours.InvalidHour.createDay(day, 'start', i, 'RANGE'));
          invalidHours.push(yext.location.hours.InvalidHour.createDay(day, 'end', i, 'RANGE'));
        } else if (!yext.location.hours.isValidHour(hour.intervals[i].start)) {
          invalidHours.push(yext.location.hours.InvalidHour.createDay(day, 'start', i, 'TIME'));
        } else if (!yext.location.hours.isValidHour(hour.intervals[i].end)) {
          invalidHours.push(yext.location.hours.InvalidHour.createDay(day, 'end', i, 'TIME'));
        }
      }
    }
  });

  return invalidHours;
};

/**
 * Generate text version of hours
 *
 * Used currently with feed upload
 */
yext.location.hours.DayHours.prototype.toText = function() {
  if (!this.hoursSpecified) {
    return '';
  }

  var self = this;
  var allText = [];

  yext.time.days.forEach(function(day) {
    var hour = self.hoursMeta[day].hour;
    var text = '';

    if (hour.intervals.length > 0) {
      // always open
      if (hour.intervals[0].start == hour.intervals[0].end) {
        text = '24 hours';
      }
      // split
      else if (hour.intervals.length > 1 && hour.intervals[1].start && hour.intervals[1].end) {
        var start = hour.intervals[0].start;
        var end = hour.intervals[0].end;
        var start2 = hour.intervals[1].start;
        var end2 = hour.intervals[1].end;

        if (!start || !end || !start2 || !end2) {
          text = 'Closed';
        } else {
          if (start || end) {
            text = start + '-' + end + ' ';
          }
          if (start2 || end2) {
            text += start2 + '-' + end2;
          }
        }
      }
      // open
      else {
        var start = hour.intervals[0].start;
        var end = hour.intervals[0].end;
        if (!start || !end) {
          text = 'Closed';
        } else {
          text = start + '-' + end;
        }
      }
    }
    // closed
    else {
      text = 'Closed';
    }

    allText.push(day + ' ' + text);
  });

  var text = allText.join(', ');
  return text + (text === '' ? '' : ' ');
};

/**
 * Instantiate HolidayHour class if corresponding field is found
 */
yext.location.hours.DayHours.prototype.createHolidayHours = function(context) {
  var $field = yext.location.hours.findHolidayHours(this.fieldName, context);
  if ($field.length) {
    this.holidayHours = new yext.location.hours.holiday.HolidayHour($field);
    this.holidayHours.setFieldData(this.get());

    var self = this;
    $(this.holidayHours).on('updated.holidayHours', function() {
      self.setFieldData();
    });
  }
};

/**
 * Show the generic error
 *
 * @param {boolean} show
 */
yext.location.hours.DayHours.prototype.toggleError = function(show) {
  this.$element.find('.field-generic-error').toggle(show);
};

/**
 * Get timestamp
 *
 * @return {string} Timestamp for hours field
 */
yext.location.hours.DayHours.prototype.getTimestamp = function() {
  return this.$element.find('.js-field-timestamp').val();
};

/**
 * clears field
 */
yext.location.hours.DayHours.prototype.clear = function() {
  this.$hoursSpecified.prop('checked', false);
  this.$hoursTable.toggle(false);
  this.hoursSpecified = false;

  this.$resetHours.toggle(false);
  this.$hoursMain.toggle(true);
  this.indeterminate = false;

  this.hours.forEach(function(hour) {
    hour.clear();
  });
};

/**
 * Generic generate hours table
 *
 * @return {!jQuery} Table element
 */
yext.location.hours.generateHoursTable = function() {
  return $('<table/>', {
    'class': 'hours-table sl-hours-table-view',
  });
};

/**
 * Generate a table row for hours or holiday hours
 *
 * @param {string} label The label for this row (day or date)
 * @param {Hour} hour Hour model
 * @return {!jQuery} The row
 */
yext.location.hours.generateHoursTableRow = function(label, hour) {
  var $tr = $('<tr tid="hours-row-display" />');

  $tr.append(yext.location.hours.createTableColumn('hours-day', label));

  if (hour.intervalIndeterminate || hour.dateIndeterminate) {
    $tr.append('<td colspan="7" class="various">&lt;' + yext.msg('Various Content') + '&gt;</td>');
    return $tr;
  }

  if (hour.intervals.length > 0) {
    // indicates an always open interval
    if (hour.intervals[0].start == hour.intervals[0].end) {
      $tr.append('<td colspan="7">' + yext.msgc('hours', 'Open 24 hours') + '</td>');
    } else {
      var $tdStart = yext.location.hours.createTableColumn('hours-left');
      var $tdSeparator = yext.location.hours.createTableColumn('hours-separator', 'to');
      var $tdEnd = yext.location.hours.createTableColumn('hours-right');

      $tr
        .append($tdStart.html(hour.intervals[0].start))
        .append($tdSeparator)
        .append($tdEnd.html(hour.intervals[0].end));

      if (hour.intervals.length > 1 && hour.intervals[1].start && hour.intervals[1].end) {
        var $tr2 = $('<tr/>');
        $tr2
          .append(yext.location.hours.createTableColumn('hours-day'))
          .append($tdStart.clone().html(hour.intervals[1].start))
          .append($tdSeparator.clone())
          .append($tdEnd.clone().html(hour.intervals[1].end));
        $tr = $tr.add($tr2);
      }
    }
  } else {
    var message = '';
    if (hour.type == 'CLOSED' || hour.displayType == 'CLOSED') {
      message = yext.msgc('hours', 'Closed');
    } else if (hour.type == 'IS_REGULAR_HOURS') {
      message = yext.msgc('hours', 'Is Regular Hours');
    }
    $tr.append('<td colspan="7">' + message + '</td>');
  }

  return $tr;
};

/**
 * Create a table column
 *
 * @param {string} className The class name to give the column
 * @param {string} content The content for the column
 */
yext.location.hours.createTableColumn = function(className, content) {
  return $('<td/>', {
    'class': className,
  }).html(content);
};

/**
 * Find holiday hours by fieldName
 *
 * @param {string} fieldName Field name from which to search holiday hours
 * @return {!jQuery} The holiday hours field
 */
yext.location.hours.findHolidayHours = function(fieldName, context) {
  var holidayHoursFieldName = fieldName;
  if (fieldName) {
    if (fieldName.startsWith('virtual.expanded')) {
      // this case is for custom hours fields in entity edit
      holidayHoursFieldName = fieldName.replace('.hours', '.holidayhours');
    } else if (fieldName.startsWith('virtual')) {
      // this case is for custom hours fields in location edit/add
      holidayHoursFieldName = fieldName.substring(0, fieldName.lastIndexOf('.hours')) + '.holidayhours';
    }
  }
  var selector = context ? context : '';
  selector += ' .js-holiday-hours-field input[name=field][value="' + holidayHoursFieldName + '"]';
  return $(selector).closest('.js-holiday-hours-field');
};

/**
 * For use with DayHour and HolidayHour when an interval has been updated.
 * Handles setting the value of inputs and doing UI updates based upon changes
 * in the hours type or the hours themselves
 *
 * @param {!Object} update Details about an update
 * @param {!Object} meta Metadata about an hour
 */
yext.location.hours.intervalUpdated = function(update, meta) {
  if (update.type) {
    // Sync ui value with hour object if necessary
    if (meta.$hoursType.val() != meta.hour.type) {
      meta.gumi.setSelected(meta.hour.type);
    }

    meta.$start.prop('disabled', false);
    meta.$end.prop('disabled', false);
    meta.$start.removeClass('hidden-text');
    meta.$end.removeClass('hidden-text');
    meta.$splitHours.hide();
    var hourType = meta.hour.type;
    switch (hourType) {
      case 'SPLIT':
        meta.$splitHours.show();
        break;
      case 'CLOSED':
      case 'IS_REGULAR_HOURS':
      case 'ALWAYS_OPEN':
        meta.$start.prop('disabled', true);
        meta.$end.prop('disabled', true);
        meta.$start.addClass('hidden-text');
        meta.$end.addClass('hidden-text');
        break;
    }
  }

  if (update.intervals) {
    var elementMap = {
      '0': {
        start: meta.$start,
        end: meta.$end,
      },
      '1': {
        start: meta.$startSplit,
        end: meta.$endSplit,
      },
    };

    update.intervals.forEach(function(interval) {
      var $element = elementMap[interval.index][interval.property];
      if ($element.val() != interval.value) {
        $element.val(interval.value);
      }
    });
  }
};

/**
 * @param {options} meta Interval metadata
 * @param {function()} onUpdate Function to trigger for any updates
 */
yext.location.hours.intervalDataBindings = function(meta, onUpdate) {
  meta.$hoursType.change(function() {
    meta.hour.update({
      type: meta.$hoursType.val(),
    });
    onUpdate();
  });

  meta.$start.inputchange(function() {
    meta.hour.updateInterval(0, 'start', meta.$start.val());
    onUpdate();
  })
    .blur(function() {
      meta.hour.updateInterval(0, 'start', meta.$start.val(), true);
      onUpdate();
    });

  meta.$end.inputchange(function() {
    meta.hour.updateInterval(0, 'end', meta.$end.val());
    onUpdate();
  })
    .blur(function() {
      meta.hour.updateInterval(0, 'end', meta.$end.val(), true);
      onUpdate();
    });

  meta.$startSplit.inputchange(function() {
    meta.hour.updateInterval(1, 'start', meta.$startSplit.val());
    onUpdate();
  })
    .blur(function() {
      meta.hour.updateInterval(1, 'start', meta.$startSplit.val(), true);
      onUpdate();
    });

  meta.$endSplit.inputchange(function() {
    meta.hour.updateInterval(1, 'end', meta.$endSplit.val());
    onUpdate();
  })
    .blur(function() {
      meta.hour.updateInterval(1, 'end', meta.$endSplit.val(), true);
      onUpdate();
    });
};

/**
 * Get hour values from elements
 *
 * @param {!Object} meta Hour metadata
 */
yext.location.hours.getHourFromMeta = function(meta) {
  meta.hour = new yext.location.hours.Hour({
    type: meta.$hoursType.val(),
  });

  if (meta.$start.val() && meta.$end.val()) {
    meta.hour.intervals.push({
      start: meta.$start.val(),
      end: meta.$end.val(),
    });
  }

  if (meta.$startSplit.val() && meta.$endSplit.val()) {
    meta.hour.intervals.push({
      start: meta.$startSplit.val(),
      end: meta.$endSplit.val(),
    });
  }

  if (meta.$selected && meta.$selected.length) {
    // Unchecked is considered indeterminate
    meta.hour.dateIndeterminate = !meta.$selected.prop('checked');
    meta.hour.selected = true;
  }

  if (meta.$hour && meta.$hour.data('interval-indeterminate')) {
    meta.hour.intervalIndetermiante = true;
  }
};

/**
 * Get the day of week string from a date string
 *
 * @param {string} date Date string
 * @return {string} Day of week (uppercase)
 */
yext.location.hours.dayOfWeek = function(date) {
  var index = (new Date(Date.parse(date))).getDay() - 1;
  if (index < 0) {
    index = 6;
  }
  return yext.time.days[index];
};

/**
 * Checks if an hour is valid
 *
 * @param {string} n Hour
 * @return {boolean} True if valid
 */
yext.location.hours.isValidHour = function(n) {
  return !n || (!isNaN(parseFloat(n)) && isFinite(n)) || /^\d{1,2}(:\d{2})?\s*[AP]M$/i.test(n);
};

/**
 * Initialize gumi on new hours fields
 *
 * @param {!jQuery} $element The select
 * @return {Gumi} Instance of gumi
 */
yext.location.hours.initGumi = function($element) {
  return $element.gumi(yext.gumiConfig).data('gumi');
};

/**
 * @constructor
 * @param {!jQuery} $element The container for the holiday hours
 */
yext.location.hours.holiday.HolidayHour = function($element) {
  this.$element = $element;
  this.$container = $element.find('.js-holiday-hours-container');
  this.$holidayHourTemplate = $($element.find('.js-holiday-hour-template').html());
  this.$holidayHourIndeterminateTemplate = $($element.find('.js-holiday-hour-indeterminate-template').html());
  this.$selectAllContainer = $element.find('.js-select-all-holiday-hours-container');
  this.$selectAll = this.$selectAllContainer.find('.js-select-all-holiday-hours');
  this.$fieldData = $element.find('.js-field-value');

  this.isBulkEdit = this.$selectAll.length;
  this.hours = [];
  this.hoursMeta = [];
  this.storedHours = [];

  this.build();
  this.storeValues();
  this.bindings();
};

yext.location.hours.holiday.HolidayHour.MAX_HOLIDAY_HOURS = 100;

/**
 * Build Hour objects from the DOM
 */
yext.location.hours.holiday.HolidayHour.prototype.build = function() {
  var self = this;

  this.$element.find('.js-holiday-hour').each(function() {
    var $this = $(this);
    var $collection = $this.add($this.next('.js-split-hours'));
    var meta;
    var intervalIndeterminate = $this.data('interval-indeterminate');

    if (intervalIndeterminate) {
      meta = self.setupIndeterminateIntervalElements($this);
      self.getHourFromMetaIntervalIndeterminate(meta);
    } else {
      meta = self.setupHourElements($collection);
      yext.location.hours.getHourFromMeta(meta);
    }

    meta.hour.date = meta.$date.data('middle-endian');
    self.hours.push(meta.hour);

    if (intervalIndeterminate) {
      self.bindIntervalIndeterminate(meta);
    } else {
      self.dataBindHour(meta);
    }
  });

  this.setSelectAll();
  this.toggleAddHolidayHours();
};

yext.location.hours.holiday.HolidayHour.prototype.toggleAddHolidayHours = function() {
  var show = this.hours.length < yext.location.hours.holiday.HolidayHour.MAX_HOLIDAY_HOURS;
  this.$element.find('.js-add-holiday-hour').toggle(show);
};

/**
 * Bind holiday hour events
 */
yext.location.hours.holiday.HolidayHour.prototype.bindings = function() {
  var self = this;

  this.$element.find('.js-add-holiday-hour').click(function() {
    self.addEmptyHour();
    if (self.hours.length > 1) {
      self.$selectAllContainer.show();
      self.setSelectAll();
      self.updateHourCount();
    }
    self.toggleAddHolidayHours();
  });

  this.$selectAll.click(function() {
    var checked = self.$selectAll.prop('checked');
    self.hoursMeta.forEach(function(meta) {
      if (!meta.hour.intervalIndeterminate) {
        meta.$selected.prop({
          checked: checked,
          indeterminate: false,
        }).trigger('change');
      }
    });
  });
};

/**
 * Do data bindings for an hour
 *
 * @param {!Object} meta Elements for an hour and the hour object
 */
yext.location.hours.holiday.HolidayHour.prototype.dataBindHour = function(meta) {
  var self = this;

  yext.time.newDatepicker(meta.$date, function(date) {
    meta.hour.update({
      date: yext.time.formatDate(date),
    });
    self.broadcast('updated');
  }, {
    beforeShow: function(input, datepicker) {
      self.beforeShowDatepicker(datepicker, meta);
    },
  });

  meta.$hour.find('.js-delete-hour').click(function(e) {
    e.stopPropagation();
    self.destroy(meta);
    self.broadcast('updated');
    self.toggleAddHolidayHours();
  });

  yext.location.hours.intervalDataBindings(meta, function() {
    self.broadcast('updated');
  });

  $(meta.hour).on('updated.hour', function(e, update) {
    yext.location.hours.intervalUpdated(update, meta);
    self.broadcast('updated');
  });

  meta.$selected.on('click change', function() {
    meta.hour.update({
      dateIndeterminate: false,
      selected: meta.$selected.prop('checked'),
    });
    self.setSelectAll();
    self.broadcast('updated');
  });
};

/**
 * Set the select all based upon other checkboxes
 */
yext.location.hours.holiday.HolidayHour.prototype.setSelectAll = function() {
  var allChecked = true;
  for (var i = 0; i < this.hours.length; i++) {
    if (!this.hours[i].intervalIndeterminate
        && (!this.hours[i].selected || this.hours[i].dateIndeterminate)) {
      allChecked = false;
      break;
    }
  }
  this.$selectAll.prop('checked', allChecked);
};

/**
 * Update the count in the select all
 */
yext.location.hours.holiday.HolidayHour.prototype.updateHourCount = function() {
  this.$selectAllContainer.find('.js-holiday-hour-count').html(this.hours.length);
};

/**
 * Setup hour elements
 *
 * @param {!jQuery} $element The holiday hour
 */
yext.location.hours.holiday.HolidayHour.prototype.setupHourElements = function($element) {
  var self = this;
  var gumi = yext.location.hours.initGumi($element.find('.js-hours-type'));

  var meta = {
    gumi: gumi,
    $hour: $element,
    $date: $element.find('.js-holiday-date'),
    $hoursType: gumi.$select,
    $start: $element.find('.js-hours-start'),
    $end: $element.find('.js-hours-end'),
    $startSplit: $element.find('.js-hours-start-split'),
    $endSplit: $element.find('.js-hours-end-split'),
    $selected: $element.find('.js-hour-selected'),
    $splitHours: $element.filter('.js-split-hours'),
  };

  // Unchecked is considered indeterminate
  if (meta.$selected.length && !meta.$selected.prop('checked')) {
    meta.$selected.prop('indeterminate', true);
  }

  this.hoursMeta.push(meta);

  return meta;
};

/**
 * To make setting dates easier, the month of the date picker will be set
 * to the month of the previously selected date
 *
 * @param {!Object} datepicker The datepicker configuration object
 * @param {!Object} meta The meta for the selected holiday hour
 */
yext.location.hours.holiday.HolidayHour.prototype.beforeShowDatepicker = function(datepicker, meta) {
  var index = this.hoursMeta.indexOf(meta);
  if (index != 0) {
    var hour = this.hoursMeta[index - 1].hour;
    datepicker.settings.defaultDate = new Date(hour.date);
  }
};

/**
 * Setup elements for hours with indeterminate intervals
 *
 * @param {!jQuery} $element The holiday hour row
 */
yext.location.hours.holiday.HolidayHour.prototype.setupIndeterminateIntervalElements = function($element) {
  var meta = {
    $hour: $element,
    $selected: $element.find('.js-hour-selected'),
    $date: $element.find('.js-holiday-date'),
    $resetIndeterminate: $element.find('.js-reset-indeterminate-hours'),
  };

  // Unchecked is considered indeterminate
  if (!meta.$selected.prop('checked')) {
    meta.$selected.prop('indeterminate', true);
  }

  this.hoursMeta.push(meta);

  return meta;
};

/**
 * Get hour details from dom for indeterminate interval case
 *
 * @param {!Object} meta Holiday hour metadata
 */
yext.location.hours.holiday.HolidayHour.prototype.getHourFromMetaIntervalIndeterminate = function(meta) {
  meta.hour = new yext.location.hours.Hour({
    intervalIndeterminate: true,
  });

  // Unchecked is considered indeterminate
  meta.hour.dateIndeterminate = !meta.$selected.prop('checked');
  meta.hour.selected = true;
};

/**
 * Bindings for intederminate interval case
 *
 * @param {!Object} meta Holiday hour metadata
 */
yext.location.hours.holiday.HolidayHour.prototype.bindIntervalIndeterminate = function(meta) {
  var self = this;

  meta.$resetIndeterminate.click(function() {
    var index = self.hoursMeta.indexOf(meta);
    self.hoursMeta.splice(index, 1);

    var newMeta = self.setupHourElements(self.$holidayHourTemplate.clone());
    newMeta.hour = meta.hour;
    newMeta.hour.type = 'OPEN';
    newMeta.hour.intervalIndeterminate = false;

    self.renderHolidayHour(newMeta);
    self.dataBindHour(newMeta);

    meta.$hour.replaceWith(newMeta.$hour.add(newMeta.$splitHours));
  });
};

/**
 * Broadcast a message
 *
 * @param {string} message The message that is being sent
 */
yext.location.hours.holiday.HolidayHour.prototype.broadcast = function(message, data) {
  $(this).trigger(message + '.holidayHours', data);
};

/**
 * Reset the holiday hours to stored values
 */
yext.location.hours.holiday.HolidayHour.prototype.reset = function() {
  this.refresh(this.storedHours);
  this.storeValues();
  this.broadcast('updated');
};

/**
 * Generate the view markup for holiday hours
 *
 * @param {boolean} showInactive True if inactive message should be shown
 */
yext.location.hours.holiday.HolidayHour.prototype.generateViewMarkup = function(showInactive) {
  if (!this.hours.length) {
    return yext.location.helpers.emptyFieldMessage();
  }

  var self = this;

  var $table = yext.location.hours.generateHoursTable();

  this.hours.forEach(function(hour) {
    var dayOfWeek = yext.location.hours.dayOfWeek(hour.date);
    // TRANSLATORS: The first parameter is the date and the second is the day of the week
    var label = yext.msg('{0} ({1})', (new Date(hour.date)).format('yMd'), yext.time.dayAbbreviations[dayOfWeek]);
    var $tr = yext.location.hours.generateHoursTableRow(label, hour);
    $table.append($tr);
  });

  // Show inactive container if needed
  if (showInactive && this.$inactive) {
    return [this.$inactive.show(), $table];
  }
  return $table;
};

/**
 * Store the current holiday hours by making copies
 */
yext.location.hours.holiday.HolidayHour.prototype.storeValues = function() {
  var self = this;

  this.storedHours = [];

  this.hours.forEach(function(hour) {
    self.storedHours.push(hour.clone());
  });
};

/**
 * Reconcile the front end with a response from the backend.
 *
 * Helps with stale updates and for sorting in this case
 *
 * @param {!Array} hours Array of objects with details about a holiday hour
 */
yext.location.hours.holiday.HolidayHour.prototype.reconcile = function(hours) {
  var _hours = [];

  hours.forEach(function(hour) {
    _hours.push(new yext.location.hours.Hour(hour));
  });

  this.refresh(_hours);
};

/**
 * Refresh the holiday hours based upon the array of hours passed
 *
 * @param {!Array.<Hour>} hours Array of Hour objects
 */
yext.location.hours.holiday.HolidayHour.prototype.refresh = function(hours) {
  var self = this;

  // Clean up everything
  this.hoursMeta.forEach(function(meta) {
    self.destroy(meta);
  });

  this.hoursMeta = [];
  this.hours = hours;
  self.$container.empty();

  this.hours.forEach(function(hour) {
    var meta;

    if (hour.intervalIndeterminate) {
      meta = self.setupIndeterminateIntervalElements(self.$holidayHourIndeterminateTemplate.clone());
    } else {
      meta = self.setupHourElements(self.$holidayHourTemplate.clone());
    }

    meta.hour = hour;
    if (self.isBulkEdit) {
      meta.hour.selected = true;
    }
    self.renderHolidayHour(meta);

    if (meta.hour.intervalIndeterminate) {
      self.bindIntervalIndeterminate(meta);
    } else {
      self.dataBindHour(meta);
    }

    self.$container.append(meta.$hour);
  });

  this.$selectAllContainer.toggle(this.hours.length > 1);

  this.setSelectAll();
  this.updateHourCount();
  this.toggleAddHolidayHours();
};

/**
 * Add empty hour
 */
yext.location.hours.holiday.HolidayHour.prototype.addEmptyHour = function() {
  var meta = this.setupHourElements(this.$holidayHourTemplate.clone());
  meta.hour = new yext.location.hours.Hour({
    type: 'OPEN',
    selected: true,
  });
  this.hours.push(meta.hour);
  this.dataBindHour(meta);
  this.$container.append(meta.$hour);
};

/**
 * Render a holiday hour edit mode
 *
 * @param {!Object} meta Metadata for a holiday hour
 */
yext.location.hours.holiday.HolidayHour.prototype.renderHolidayHour = function(meta) {
  var date = new Date(meta.hour.date);
  meta.$date.val(date.format('yMd')).trigger('change');

  if (!meta.hour.intervalIndeterminate) {
    var update = {
      type: meta.hour.type,
      intervals: yext.location.hours.Hour.intervalsToUpdate(meta.hour.intervals),
    };
    yext.location.hours.intervalUpdated(update, meta);
  }

  if (meta.$selected) {
    meta.$selected.prop({
      checked: !meta.hour.dateIndeterminate,
      indeterminate: meta.hour.dateIndeterminate,
    });
  }
};

/**
 * Remove a holiday hour
 *
 * @param {!Object} meta Hour metadata
 * @suppress {deprecated}
 */
yext.location.hours.holiday.HolidayHour.prototype.destroy = function(meta) {
  // Check first since interval indeterminate does not initialize datepicker
  if (meta.$date.data('datepicker')) {
    meta.$date.datepicker('destroy');
  }

  $(meta.hour).off('.hour');

  var metaIndex = this.hoursMeta.indexOf(meta);
  var hourIndex = this.hours.indexOf(meta.hour);

  this.hoursMeta.splice(metaIndex, 1);
  this.hours.splice(hourIndex, 1);

  meta.$date.closest('tr').remove();

  if (meta.$splitHours) {
    meta.$splitHours.remove();
  }
};

/**
 * Set the hidden input with the value of the field
 *
 * @param {!Object} data Hours and holiday hours data
 */
yext.location.hours.holiday.HolidayHour.prototype.setFieldData = function(data) {
  data.fieldUpdated = 'HOLIDAY_HOURS';
  this.$fieldData.val(yext.JSON.stringify(data));
};

/**
 * Get holiday hours
 *
 * In the case of bulk edit only the hours with selected == true will be included
 *
 * @return {!Array.<Hour>} List of holiday hours
 */
yext.location.hours.holiday.HolidayHour.prototype.get = function() {
  if (this.isBulkEdit) {
    var hours = [];
    this.hours.forEach(function(hour) {
      if (hour.selected) {
        var clone = hour.clone();
        delete clone.selected; // Small clean up
        hours.push(clone);
      }
    });
    return hours;
  } else {
    return this.hours;
  }
};

/**
 * @param {!jQuery} $display The display container
 */
yext.location.hours.holiday.HolidayHour.prototype.setDisplay = function($display) {
  this.$display = $display;
  this.$inactive = $display.find('.js-holiday-inactive-message');
};
